import { Loader2, X } from 'lucide-react';
import { useSnapshot } from 'valtio';
import {
  operationsStore,
  stopOperation,
} from '@/lib/operations/operation-manager';

export function ActiveOperationsBanner() {
  const snap = useSnapshot(operationsStore);

  const running = Object.entries(snap).filter(
    ([, op]) => op.status === 'running'
  );

  if (running.length === 0) return null;

  return (
    <div className='fixed bottom-6 left-1/2 -translate-x-1/2 z-50 mb-[env(safe-area-inset-bottom)] animate-in slide-in-from-bottom fade-in duration-300'>
      <div className='bg-primary/95 text-primary-foreground backdrop-blur-sm rounded-xl shadow-lg px-4 py-2.5 flex items-center gap-3'>
        <Loader2 className='h-4 w-4 animate-spin shrink-0' />
        <span className='text-sm whitespace-nowrap'>
          {running.map(([, op]) => op.label).join(', ')}
        </span>
        {running.map(([key]) => (
          <button
            key={key}
            onClick={() => stopOperation(key)}
            className='p-1 rounded-full hover:bg-primary-foreground/20 transition-colors shrink-0'
            aria-label='Cancel operation'
          >
            <X className='h-3.5 w-3.5' />
          </button>
        ))}
      </div>
    </div>
  );
}
